import { FunctionComponent } from "react";

import Button from "@ui/components/cta/Button";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";
import { useAuth } from "@voxmedia/duet-context/context/auth-context";

import * as styles from "./VergeSubscribeButton.css";

const VergeSubscribeButton: FunctionComponent = () => {
  const analytics = useAnalytics();
  const auth = useAuth();

  if (auth.user?.isEntitled) {
    return null;
  }

  return (
    <Button
      className={styles.subscribeButton}
      displayType="secondary"
      text="Subscribe"
      href="/subscribe?itm_campaign=menu-nav-subscribe&itm_medium=site&itm_source=navigation"
      onClick={() => {
        analytics?.emit({
          event: "memberships_navigation",
          memberships_navigation: {
            action: "click",
            cta: "Subscribe",
            position: "navigation",
          },
        });
      }}
      fullWidth
    />
  );
};

export default VergeSubscribeButton;
